import { trpc } from '@/shared/api/trpc';
import { notificationListInput } from './use-notifications';

// Mark every unread notification read. Server-side it only touches rows that
// are still unread, so it never rewrites an existing read time.
//
// Optimistic for the same reason as `useMarkRead`: the badge must clear on
// click. The count goes straight to 0 rather than being decremented, so it
// cannot drift negative when the cached page holds fewer rows than the count.
export const useMarkAllRead = () => {
  const utils = trpc.useUtils();

  return trpc.notifications.markAllRead.useMutation({
    onMutate: async () => {
      await Promise.all([
        utils.notifications.list.cancel(),
        utils.notifications.unreadCount.cancel(),
      ]);

      const previousList = utils.notifications.list.getInfiniteData(
        notificationListInput
      );
      const previousCount = utils.notifications.unreadCount.getData();

      const readOn = new Date().toISOString();
      utils.notifications.list.setInfiniteData(notificationListInput, (old) =>
        old
          ? {
              ...old,
              pages: old.pages.map((page) => ({
                ...page,
                data: page.data.map((row) =>
                  row.readOn === null ? { ...row, readOn } : row
                ),
              })),
            }
          : old
      );
      utils.notifications.unreadCount.setData(undefined, 0);

      return { previousList, previousCount };
    },

    onError: (_error, _variables, context) => {
      if (context?.previousList !== undefined) {
        utils.notifications.list.setInfiniteData(
          notificationListInput,
          context.previousList
        );
      }
      if (context?.previousCount !== undefined) {
        utils.notifications.unreadCount.setData(
          undefined,
          context.previousCount
        );
      }
    },

    onSettled: () => {
      utils.notifications.list.invalidate();
      utils.notifications.unreadCount.invalidate();
    },
  });
};
